// extracted by mini-css-extract-plugin
export const leftImage = "Styles-module--leftImage--MRTpz";
export const subProductsContainer = "Styles-module--subProductsContainer--2yArS";
export const subProduct = "Styles-module--subProduct--3vJNN";